import React, { Fragment } from "react";
import { Formik, Form, FieldArray } from "formik";
import { Row, Col } from "react-flexbox-grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import DetailsSection from "./details-section";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import DeleteIcon from "@material-ui/icons/Delete";
import FileSelector from "./file-selector";
import BorderZone from "../../border-zone";
import DescriptionsArray from "../../descriptions";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit * 1
  }
});

const Files = values => arrayHelpers => {
  const fields = values.files ? values.files.map((file, index) => {
    return (
      <Fragment key={file.id}>
        <ListItem>
          <ListItemText primary={file.name} secondary={file.filename} />
          <ListItemSecondaryAction>
            <IconButton
              aria-label="Delete"
              onClick={() => arrayHelpers.remove(index)}
            >
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
        <Divider />
      </Fragment>
    );
  }) : [];

  return (
    <Row end="xs">
      <Col xs={12}>
        <List>{fields}</List>
      </Col>
      <Col xs={12}>
        <FileSelector
          files={values.files}
          onSubmit={item => {
            arrayHelpers.push(item);
          }}
        />
      </Col>
    </Row>
  );
};

const IndicatorSubItem = props => {
  const {
    subItemKey,
    subItemTitle,
    indicator,
    classes,
    onSubmit,
    indicatorId,
    title=true,
  } = props;
  
  return (
    <DetailsSection title={title ? subItemTitle : ''}>
      <Formik
        initialValues={{
          description: indicator && indicator[subItemKey] ? indicator[subItemKey].description : null,
          files: indicator && indicator[subItemKey] ? indicator[subItemKey].files : null
        }}
        onSubmit={values => {
          const {inequalities, generalities} = indicator;
          let mappedFileValuesInequalities = [];
          let mappedFileValuesGeneralities = [];

          if(subItemKey === 'generalities'){
            mappedFileValuesInequalities = Object.assign({}, values, {
              description : inequalities.description ? inequalities.description : '',
              files       : inequalities.files ? inequalities.files.map(file => file.id ? file.id : file) : [],
            });
          } else{
            mappedFileValuesGeneralities = Object.assign({}, values, {
              description : generalities.description ? generalities.description : '',
              files       : generalities.files ? generalities.files.map(file => file.id ? file.id : file) : [],
            });
          }

          const mappedFileValues = Object.assign({}, values, {
            files: values.files ? values.files.map(file => file.id) : []
          });
          const newValues = Object.assign({}, indicator, {
            generalities : subItemKey === 'generalities' ? mappedFileValues : mappedFileValuesGeneralities,
            inequalities : subItemKey === 'inequalities' ? mappedFileValues : mappedFileValuesInequalities,
            tags         : indicator.tags.map(item => item._id ? item._id : item),
          });
          onSubmit({ variables: { id: indicatorId, indicator: newValues } });
        }}
      >
        {({ values }) => {
          return (
            <Form>
              <Row>
                <Col xs={12} md={6}>
                  <BorderZone title="Descripción">
                    <FieldArray name="description">
                      {helpers => (
                        <DescriptionsArray
                          itemKey="description"
                          label="Parrafo"
                          values={values}
                          arrayHelpers={helpers}
                        />
                      )}
                    </FieldArray>
                  </BorderZone>
                </Col>
                <Col xs={12} md={6}>
                  <BorderZone title="Archivos">
                    <FieldArray name="files">{Files(values)}</FieldArray>
                  </BorderZone>
                </Col>
                <Col xs={12}>
                  <Divider />
                </Col>
              </Row>
              <Row end="xs">
                <Col xs={12}>
                  <Divider />
                </Col>
                <Col xs={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    type="submit"
                  >
                    Guardar Información de {subItemTitle}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      </Formik>
    </DetailsSection>
  );
};

export default withStyles(styles)(IndicatorSubItem);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/indicator-subitem.js